import { SupportedLanguages } from '../types';
import { getTwoLetterLanguageCode, isHomePage } from './index';

const isEnglishPage = (pathname: string) => {
    return pathname.startsWith(`/${SupportedLanguages.en}/`);
};

export const getCanonicalLink = (location: Location) => {
    let result = isEnglishPage(location.pathname) ? location.pathname.slice(3) : location.pathname;

    if (!result.endsWith('/')) {
        result += '/';
    }

    return result;
};

export const getAlternateLink = ({ language, uid }: { language: string; uid: string }): string => {
    const languageAbbreviation = getTwoLetterLanguageCode(language);
    let result = '/';

    if (languageAbbreviation !== SupportedLanguages.en) {
        result += `${languageAbbreviation}/`;
    }

    if (!isHomePage(uid)) {
        result += `${uid}/`;
    }

    return result;
};
